// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Apollo$SmartcutsMacros = require("./Apollo.bs.js");
var Config$SmartcutsMacros = require("../../bs-macros-extension/src/Config.bs.js");
var Segment$SmartcutsMacros = require("../../bs-analytics/src/Segment.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var ResultUtils$SmartcutsMacros = require("../../bs-utils/src/ResultUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");
var DataStoreUtils$SmartcutsMacros = require("./DataStoreUtils.bs.js");
var ApolloClient__React_Hooks_UseQuery = require("rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var ApolloClient__React_Hooks_UseMutation = require("rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.bs.js");

var Raw = {};

var query = (require("@apollo/client").gql`
  mutation createUser($user: CreateUserInput!)  {
    createUser(input: $user)  {
      __typename
      _id
      email
      role
      active
      inviteToken
      build
    }
  }
`);

function parse(value) {
  var value$1 = value.createUser;
  var value$2 = value$1.role;
  var tmp;
  switch (value$2) {
    case "CUSTOMER" :
        tmp = "CUSTOMER";
        break;
    case "REVIEWER" :
        tmp = "REVIEWER";
        break;
    case "SUPERADMIN" :
        tmp = "SUPERADMIN";
        break;
    case "WAITLIST" :
        tmp = "WAITLIST";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$2
      };
  }
  var value$3 = value$1.inviteToken;
  var value$4 = value$1.build;
  var tmp$1;
  if (value$4 == null) {
    tmp$1 = undefined;
  } else {
    var tmp$2 = value$4 === "CANARY" ? "CANARY" : ({
          NAME: "FutureAddedValue",
          VAL: value$4
        });
    tmp$1 = tmp$2;
  }
  return {
          createUser: {
            __typename: value$1.__typename,
            _id: value$1._id,
            email: value$1.email,
            role: tmp,
            active: value$1.active,
            inviteToken: !(value$3 == null) ? value$3 : undefined,
            build: tmp$1
          }
        };
}

function serialize(value) {
  var value$1 = value.createUser;
  var value$2 = value$1.build;
  var build = value$2 !== undefined ? (
      typeof value$2 === "object" ? value$2.VAL : "CANARY"
    ) : null;
  var value$3 = value$1.inviteToken;
  var inviteToken = value$3 !== undefined ? value$3 : null;
  var value$4 = value$1.active;
  var value$5 = value$1.role;
  var role = typeof value$5 === "object" ? value$5.VAL : (
      value$5 === "CUSTOMER" ? "CUSTOMER" : (
          value$5 === "REVIEWER" ? "REVIEWER" : (
              value$5 === "WAITLIST" ? "WAITLIST" : "SUPERADMIN"
            )
        )
    );
  var value$6 = value$1.email;
  var value$7 = value$1._id;
  var value$8 = value$1.__typename;
  var createUser = {
    __typename: value$8,
    _id: value$7,
    email: value$6,
    role: role,
    active: value$4,
    inviteToken: inviteToken,
    build: build
  };
  return {
          createUser: createUser
        };
}

function serializeInputObjectCreateUserInput(inp) {
  var a = inp.role;
  var a$1 = inp.inviteToken;
  var a$2 = inp.build;
  return {
          email: inp.email,
          password: inp.password,
          role: a === "CUSTOMER" ? "CUSTOMER" : (
              a === "REVIEWER" ? "REVIEWER" : (
                  a === "WAITLIST" ? "WAITLIST" : "SUPERADMIN"
                )
            ),
          active: inp.active,
          inviteToken: a$1 !== undefined ? a$1 : undefined,
          build: a$2 !== undefined ? "CANARY" : undefined
        };
}

function serializeVariables(inp) {
  return {
          user: serializeInputObjectCreateUserInput(inp.user)
        };
}

function makeVariables(user, param) {
  return {
          user: user
        };
}

function makeInputObjectCreateUserInput(email, password, role, active, inviteToken, build, param) {
  return {
          email: email,
          password: password,
          role: role,
          active: active,
          inviteToken: inviteToken,
          build: build
        };
}

var CreateUser_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectCreateUserInput: serializeInputObjectCreateUserInput,
  makeVariables: makeVariables,
  makeInputObjectCreateUserInput: makeInputObjectCreateUserInput
};

var include = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var CreateUser_use = include.use;

var CreateUser_useWithVariables = include.useWithVariables;

var CreateUser = {
  CreateUser_inner: CreateUser_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectCreateUserInput: serializeInputObjectCreateUserInput,
  makeVariables: makeVariables,
  makeInputObjectCreateUserInput: makeInputObjectCreateUserInput,
  use: CreateUser_use,
  useWithVariables: CreateUser_useWithVariables
};

var Raw$1 = {};

var query$1 = (require("@apollo/client").gql`
  mutation ($id: ID!, $partialUpdate: PartialUpdateUserInput!)  {
    partialUpdateUser(id: $id, data: $partialUpdate)  {
      __typename
      _id
    }
  }
`);

function parse$1(value) {
  var value$1 = value.partialUpdateUser;
  return {
          partialUpdateUser: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                _id: value$1._id
              }) : undefined
        };
}

function serialize$1(value) {
  var value$1 = value.partialUpdateUser;
  var partialUpdateUser;
  if (value$1 !== undefined) {
    var value$2 = value$1._id;
    var value$3 = value$1.__typename;
    partialUpdateUser = {
      __typename: value$3,
      _id: value$2
    };
  } else {
    partialUpdateUser = null;
  }
  return {
          partialUpdateUser: partialUpdateUser
        };
}

function serializeInputObjectPlanSubscriptionServicePlanRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectServicePlanInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectPlanSubscriptionCustomerRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectUserInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectFailureInput(inp) {
  var a = inp.user;
  var a$1 = inp.kind;
  var a$2 = inp.errorName;
  var a$3 = inp.errorMessage;
  var a$4 = inp.extensionVersion;
  return {
          user: a !== undefined ? serializeInputObjectFailureUserRelation(a) : undefined,
          kind: a$1 === "BG_FAILURE_CASE" ? "BG_FAILURE_CASE" : "CONTENT_SCRIPT_FAILURE_CASE",
          failWith: inp.failWith,
          errorName: a$2 !== undefined ? a$2 : undefined,
          errorMessage: a$3 !== undefined ? a$3 : undefined,
          serialized: inp.serialized,
          extensionVersion: a$4 !== undefined ? a$4 : undefined,
          archived: inp.archived
        };
}

function serializeInputObjectUserInput(inp) {
  var a = inp.inviteToken;
  var a$1 = inp.role;
  var a$2 = inp.failures;
  var a$3 = inp.authoredSmartcuts;
  var a$4 = inp.topSites;
  var a$5 = inp.installedSmartcuts;
  var a$6 = inp.scheduledTriggers;
  var a$7 = inp.build;
  var a$8 = inp.subscriptions;
  var a$9 = inp.userFlags;
  var a$10 = inp.finishedOnboarding;
  var a$11 = inp.completedExtraStepsBonuses;
  var a$12 = inp.credentials;
  return {
          email: inp.email,
          inviteToken: a !== undefined ? a : undefined,
          role: a$1 === "CUSTOMER" ? "CUSTOMER" : (
              a$1 === "REVIEWER" ? "REVIEWER" : (
                  a$1 === "WAITLIST" ? "WAITLIST" : "SUPERADMIN"
                )
            ),
          active: inp.active,
          failures: a$2 !== undefined ? serializeInputObjectUserFailuresRelation(a$2) : undefined,
          authoredSmartcuts: a$3 !== undefined ? serializeInputObjectUserAuthoredSmartcutsRelation(a$3) : undefined,
          topSites: a$4 !== undefined ? a$4.map(serializeInputObjectUrlWithTitleInput) : undefined,
          installedSmartcuts: a$5 !== undefined ? serializeInputObjectUserInstalledSmartcutsRelation(a$5) : undefined,
          scheduledTriggers: a$6 !== undefined ? serializeInputObjectUserScheduledTriggersRelation(a$6) : undefined,
          build: a$7 !== undefined ? "CANARY" : undefined,
          subscriptions: a$8 !== undefined ? serializeInputObjectUserSubscriptionsRelation(a$8) : undefined,
          userFlags: a$9 !== undefined ? a$9.map(function (b) {
                  return b;
                }) : undefined,
          finishedOnboarding: a$10 !== undefined ? a$10 : undefined,
          completedExtraStepsBonuses: a$11 !== undefined ? a$11.map(function (b) {
                  return "TWEET_SMARTCUTS";
                }) : undefined,
          credentials: a$12 !== undefined ? serializeInputObjectUserCredentialsRelation(a$12) : undefined
        };
}

function serializeInputObjectRecordedSmartcutInput(inp) {
  var a = inp.author;
  var a$1 = inp.description;
  var a$2 = inp.startingUrlPattern;
  var a$3 = inp.origins;
  var a$4 = inp.screens;
  var a$5 = inp.commandLog;
  var a$6 = inp.recordingCommandLog;
  var a$7 = inp.authoringCommandLog;
  var a$8 = inp.smartcut;
  var a$9 = inp.recordingStartedAt;
  var a$10 = inp.recordingEndedAt;
  return {
          author: a !== undefined ? serializeInputObjectRecordedSmartcutAuthorRelation(a) : undefined,
          name: inp.name,
          description: a$1 !== undefined ? a$1 : undefined,
          startingUrlPattern: a$2 !== undefined ? a$2 : undefined,
          origins: a$3.map(function (b) {
                return b;
              }),
          screens: a$4 !== undefined ? a$4.map(serializeInputObjectScreenInput) : undefined,
          schemaVersion: inp.schemaVersion,
          commandLog: a$5 !== undefined ? serializeInputObjectRecordedSmartcutCommandLogRelation(a$5) : undefined,
          recordingCommandLog: a$6 !== undefined ? serializeInputObjectRecordedSmartcutRecordingCommandLogRelation(a$6) : undefined,
          authoringCommandLog: a$7 !== undefined ? serializeInputObjectRecordedSmartcutAuthoringCommandLogRelation(a$7) : undefined,
          numCommands: inp.numCommands,
          numRecordingCommands: inp.numRecordingCommands,
          numAuthoringCommands: inp.numAuthoringCommands,
          commandsSize: inp.commandsSize,
          recordingCommandsSize: inp.recordingCommandsSize,
          authoringCommandsSize: inp.authoringCommandsSize,
          smartcutRevision: inp.smartcutRevision,
          smartcut: a$8 !== undefined ? serializeInputObjectRecordedSmartcutSmartcutRelation(a$8) : undefined,
          recordingStartedAt: a$9 !== undefined ? Caml_option.valFromOption(a$9) : undefined,
          recordingEndedAt: a$10 !== undefined ? Caml_option.valFromOption(a$10) : undefined
        };
}

function serializeInputObjectUserAuthoredSmartcutsRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectSmartcutInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectUserScheduledTriggersRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectScheduledTriggerInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectUserCredentialsRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectUserCredentialEntryInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectUserInstalledSmartcutsRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectInstalledSmartcutInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectUserSubscriptionsRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectPlanSubscriptionInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectPartialUpdateUrlWithTitleInput(inp) {
  var a = inp.url;
  var a$1 = inp.title;
  return {
          url: a !== undefined ? a : undefined,
          title: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectUserFailuresRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectFailureInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectRecordingCommandLogEntryInput(inp) {
  var a = inp.recordedSmartcut;
  var a$1 = inp.dextSchemaVersion;
  return {
          recordedSmartcut: a !== undefined ? serializeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation(a) : undefined,
          index: inp.index,
          commandSerialized: inp.commandSerialized,
          contextSerialized: inp.contextSerialized,
          schemaVersion: inp.schemaVersion,
          size: inp.size,
          dextSchemaVersion: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectFailureUserRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? serializeInputObjectUserInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined,
          disconnect: a$2 !== undefined ? a$2 : undefined
        };
}

function serializeInputObjectAuthoringCommandLogEntryInput(inp) {
  var a = inp.recordedSmartcut;
  var a$1 = inp.dextSchemaVersion;
  return {
          recordedSmartcut: a !== undefined ? serializeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation(a) : undefined,
          index: inp.index,
          commandSerialized: inp.commandSerialized,
          contextSerialized: inp.contextSerialized,
          schemaVersion: inp.schemaVersion,
          size: inp.size,
          dextSchemaVersion: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectMainCommandLogEntryRecordedSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectRecordedSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectScheduledTriggerInput(inp) {
  var a = inp.smartcut;
  var a$1 = inp.user;
  var a$2 = inp.status;
  var a$3 = inp.maybeLastCheckedAt;
  return {
          smartcut: a !== undefined ? serializeInputObjectScheduledTriggerSmartcutRelation(a) : undefined,
          user: a$1 !== undefined ? serializeInputObjectScheduledTriggerUserRelation(a$1) : undefined,
          status: a$2 === "ACTIVE" ? "ACTIVE" : (
              a$2 === "PAUSED" ? "PAUSED" : "ARCHIVED"
            ),
          schedulePeriodSerialized: inp.schedulePeriodSerialized,
          dataSourceSerialized: inp.dataSourceSerialized,
          playbackOptionsSerialized: inp.playbackOptionsSerialized,
          commandSchemaVersion: inp.commandSchemaVersion,
          playbackOptionsSchemaVersion: inp.playbackOptionsSchemaVersion,
          maybeLastCheckedAt: a$3 !== undefined ? Caml_option.valFromOption(a$3) : undefined
        };
}

function serializeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectRecordedSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectMainCommandLogEntryInput(inp) {
  var a = inp.recordedSmartcut;
  var a$1 = inp.dextSchemaVersion;
  return {
          recordedSmartcut: a !== undefined ? serializeInputObjectMainCommandLogEntryRecordedSmartcutRelation(a) : undefined,
          index: inp.index,
          commandSerialized: inp.commandSerialized,
          contextSerialized: inp.contextSerialized,
          schemaVersion: inp.schemaVersion,
          size: inp.size,
          dextSchemaVersion: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectInstalledSmartcutInput(inp) {
  var a = inp.owner;
  var a$1 = inp.smartcut;
  var a$2 = inp.recordedSmartcut;
  var a$3 = inp.smartcutParamDefaults;
  var a$4 = inp.scheduledTriggers;
  var a$5 = inp.defaultPlaybackOptionsSerialized;
  var a$6 = inp.playbackOptionsSchemaVersion;
  return {
          owner: a !== undefined ? serializeInputObjectInstalledSmartcutOwnerRelation(a) : undefined,
          schemaVersion: inp.schemaVersion,
          smartcut: a$1 !== undefined ? serializeInputObjectInstalledSmartcutSmartcutRelation(a$1) : undefined,
          smartcutRevision: inp.smartcutRevision,
          recordedSmartcut: a$2 !== undefined ? serializeInputObjectInstalledSmartcutRecordedSmartcutRelation(a$2) : undefined,
          smartcutParamDefaults: a$3.map(serializeInputObjectSmartcutParamInput),
          scheduledTriggers: a$4 !== undefined ? serializeInputObjectInstalledSmartcutScheduledTriggersRelation(a$4) : undefined,
          defaultPlaybackOptionsSerialized: a$5 !== undefined ? a$5 : undefined,
          playbackOptionsSchemaVersion: a$6 !== undefined ? a$6 : undefined
        };
}

function serializeInputObjectInstalledSmartcutScheduledTriggersRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectScheduledTriggerInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectSmartcutParamInput(inp) {
  var a = inp.otherCommandIndexes;
  return {
          firstCommandIndex: inp.firstCommandIndex,
          otherCommandIndexes: a.map(function (b) {
                return b;
              }),
          param: inp.param
        };
}

function serializeInputObjectInstalledSmartcutRecordedSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectRecordedSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectInstalledSmartcutSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectInstalledSmartcutOwnerRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectUserInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectUserCredentialEntryInput(inp) {
  var a = inp.user;
  return {
          user: a !== undefined ? serializeInputObjectUserCredentialEntryUserRelation(a) : undefined,
          hostname: inp.hostname,
          credentialSchemaVersion: inp.credentialSchemaVersion,
          credentialSerialized: inp.credentialSerialized
        };
}

function serializeInputObjectSmartcutInput(inp) {
  var a = inp.author;
  var a$1 = inp.description;
  var a$2 = inp.visibility;
  var a$3 = inp.startingUrlPattern;
  var a$4 = inp.maybeRedirectedFromUrlPatterns;
  var a$5 = inp.origins;
  var a$6 = inp.screens;
  var a$7 = inp.recordedSmartcut;
  var a$8 = inp.smartcutParams;
  var a$9 = inp.stepDescriptions;
  var a$10 = inp.msBeforeNextCommand;
  var a$11 = inp.defaultPlaybackOptionsSerialized;
  var a$12 = inp.playbackOptionsSchemaVersion;
  var a$13 = inp.topic;
  var a$14 = inp.priorityInTopic;
  var a$15 = inp.maybeMsBeforeCloseWindow;
  var a$16 = inp.loginUrls;
  var a$17 = inp.loginSmartcutRefsSerialized;
  return {
          author: a !== undefined ? serializeInputObjectSmartcutAuthorRelation(a) : undefined,
          name: inp.name,
          description: a$1 !== undefined ? a$1 : undefined,
          visibility: a$2 === "PRIVATE" ? "PRIVATE" : (
              a$2 === "PUBLIC" ? "PUBLIC" : "UNLISTED"
            ),
          schemaVersion: inp.schemaVersion,
          currentRevision: inp.currentRevision,
          startingUrlPattern: a$3 !== undefined ? a$3 : undefined,
          maybeRedirectedFromUrlPatterns: a$4 !== undefined ? a$4.map(function (b) {
                  return b;
                }) : undefined,
          numCommands: inp.numCommands,
          origins: a$5.map(function (b) {
                return b;
              }),
          screens: a$6 !== undefined ? a$6.map(serializeInputObjectScreenInput) : undefined,
          recordedSmartcut: a$7 !== undefined ? serializeInputObjectSmartcutRecordedSmartcutRelation(a$7) : undefined,
          smartcutParams: a$8.map(serializeInputObjectSmartcutParamInput),
          stepDescriptions: a$9 !== undefined ? a$9.map(function (b) {
                  return b;
                }) : undefined,
          msBeforeNextCommand: a$10 !== undefined ? a$10.map(function (b) {
                  return b;
                }) : undefined,
          defaultPlaybackOptionsSerialized: a$11 !== undefined ? a$11 : undefined,
          playbackOptionsSchemaVersion: a$12 !== undefined ? a$12 : undefined,
          topic: a$13 !== undefined ? a$13 : undefined,
          priorityInTopic: a$14 !== undefined ? (
              a$14 === "STARTER_KIT" ? "STARTER_KIT" : (
                  a$14 === "RECOMMENDED" ? "RECOMMENDED" : "ONBORDING_DEMO"
                )
            ) : undefined,
          maybeMsBeforeCloseWindow: a$15 !== undefined ? a$15 : undefined,
          loginUrls: a$16 !== undefined ? a$16.map(function (b) {
                  return b;
                }) : undefined,
          loginSmartcutRefsSerialized: a$17 !== undefined ? a$17 : undefined
        };
}

function serializeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectRecordedSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectServicePlanInput(inp) {
  var a = inp.executionLimits;
  return {
          name: inp.name,
          description: inp.description,
          executionLimits: a !== undefined ? a : undefined,
          executionSteps: inp.executionSteps,
          subscriptionPrice: inp.subscriptionPrice
        };
}

function serializeInputObjectPlanSubscriptionInput(inp) {
  var a = inp.customer;
  var a$1 = inp.servicePlan;
  var a$2 = inp.remainingExecutions;
  var a$3 = inp.subtotal;
  var a$4 = inp.stripeCustomerId;
  return {
          customer: a !== undefined ? serializeInputObjectPlanSubscriptionCustomerRelation(a) : undefined,
          servicePlan: a$1 !== undefined ? serializeInputObjectPlanSubscriptionServicePlanRelation(a$1) : undefined,
          remainingExecutions: a$2 !== undefined ? a$2 : undefined,
          remainingExecutionSteps: inp.remainingExecutionSteps,
          expirationDate: inp.expirationDate,
          autoRenewal: inp.autoRenewal,
          subtotal: a$3 !== undefined ? a$3 : undefined,
          stripeCustomerId: a$4 !== undefined ? a$4 : undefined
        };
}

function serializeInputObjectSmartcutAuthorRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectUserInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectSmartcutRecordedSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectRecordedSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectScreenInput(inp) {
  return {
          ikId: inp.ikId,
          url: inp.url
        };
}

function serializeInputObjectUserCredentialEntryUserRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectUserInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectScheduledTriggerUserRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectUserInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectScheduledTriggerSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectInstalledSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectRecordedSmartcutRecordingCommandLogRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectRecordingCommandLogEntryInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectRecordedSmartcutCommandLogRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectMainCommandLogEntryInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectRecordedSmartcutSmartcutRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectSmartcutInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectRecordedSmartcutAuthorRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  return {
          create: a !== undefined ? serializeInputObjectUserInput(a) : undefined,
          connect: a$1 !== undefined ? a$1 : undefined
        };
}

function serializeInputObjectRecordedSmartcutAuthoringCommandLogRelation(inp) {
  var a = inp.create;
  var a$1 = inp.connect;
  var a$2 = inp.disconnect;
  return {
          create: a !== undefined ? a.map(function (b) {
                  if (b !== undefined) {
                    return serializeInputObjectAuthoringCommandLogEntryInput(b);
                  }
                  
                }) : undefined,
          connect: a$1 !== undefined ? a$1.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined,
          disconnect: a$2 !== undefined ? a$2.map(function (b) {
                  if (b !== undefined) {
                    return b;
                  }
                  
                }) : undefined
        };
}

function serializeInputObjectUrlWithTitleInput(inp) {
  return {
          url: inp.url,
          title: inp.title
        };
}

function serializeInputObjectPartialUpdateUserInput(inp) {
  var a = inp.email;
  var a$1 = inp.inviteToken;
  var a$2 = inp.role;
  var a$3 = inp.active;
  var a$4 = inp.failures;
  var a$5 = inp.authoredSmartcuts;
  var a$6 = inp.topSites;
  var a$7 = inp.installedSmartcuts;
  var a$8 = inp.scheduledTriggers;
  var a$9 = inp.build;
  var a$10 = inp.subscriptions;
  var a$11 = inp.userFlags;
  var a$12 = inp.finishedOnboarding;
  var a$13 = inp.completedExtraStepsBonuses;
  var a$14 = inp.credentials;
  return {
          email: a !== undefined ? a : undefined,
          inviteToken: a$1 !== undefined ? a$1 : undefined,
          role: a$2 !== undefined ? (
              a$2 === "CUSTOMER" ? "CUSTOMER" : (
                  a$2 === "REVIEWER" ? "REVIEWER" : (
                      a$2 === "WAITLIST" ? "WAITLIST" : "SUPERADMIN"
                    )
                )
            ) : undefined,
          active: a$3 !== undefined ? a$3 : undefined,
          failures: a$4 !== undefined ? serializeInputObjectUserFailuresRelation(a$4) : undefined,
          authoredSmartcuts: a$5 !== undefined ? serializeInputObjectUserAuthoredSmartcutsRelation(a$5) : undefined,
          topSites: a$6 !== undefined ? a$6.map(serializeInputObjectPartialUpdateUrlWithTitleInput) : undefined,
          installedSmartcuts: a$7 !== undefined ? serializeInputObjectUserInstalledSmartcutsRelation(a$7) : undefined,
          scheduledTriggers: a$8 !== undefined ? serializeInputObjectUserScheduledTriggersRelation(a$8) : undefined,
          build: a$9 !== undefined ? "CANARY" : undefined,
          subscriptions: a$10 !== undefined ? serializeInputObjectUserSubscriptionsRelation(a$10) : undefined,
          userFlags: a$11 !== undefined ? a$11.map(function (b) {
                  return b;
                }) : undefined,
          finishedOnboarding: a$12 !== undefined ? a$12 : undefined,
          completedExtraStepsBonuses: a$13 !== undefined ? a$13.map(function (b) {
                  return "TWEET_SMARTCUTS";
                }) : undefined,
          credentials: a$14 !== undefined ? serializeInputObjectUserCredentialsRelation(a$14) : undefined
        };
}

function serializeVariables$1(inp) {
  return {
          id: inp.id,
          partialUpdate: serializeInputObjectPartialUpdateUserInput(inp.partialUpdate)
        };
}

function makeVariables$1(id, partialUpdate, param) {
  return {
          id: id,
          partialUpdate: partialUpdate
        };
}

function makeInputObjectPartialUpdateUserInput(email, inviteToken, role, active, failures, authoredSmartcuts, topSites, installedSmartcuts, scheduledTriggers, build, subscriptions, userFlags, finishedOnboarding, completedExtraStepsBonuses, credentials, param) {
  return {
          email: email,
          inviteToken: inviteToken,
          role: role,
          active: active,
          failures: failures,
          authoredSmartcuts: authoredSmartcuts,
          topSites: topSites,
          installedSmartcuts: installedSmartcuts,
          scheduledTriggers: scheduledTriggers,
          build: build,
          subscriptions: subscriptions,
          userFlags: userFlags,
          finishedOnboarding: finishedOnboarding,
          completedExtraStepsBonuses: completedExtraStepsBonuses,
          credentials: credentials
        };
}

function makeInputObjectUserFailuresRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectFailureInput(user, kind, failWith, errorName, errorMessage, serialized, extensionVersion, archived, param) {
  return {
          user: user,
          kind: kind,
          failWith: failWith,
          errorName: errorName,
          errorMessage: errorMessage,
          serialized: serialized,
          extensionVersion: extensionVersion,
          archived: archived
        };
}

function makeInputObjectFailureUserRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectUserInput(email, inviteToken, role, active, failures, authoredSmartcuts, topSites, installedSmartcuts, scheduledTriggers, build, subscriptions, userFlags, finishedOnboarding, completedExtraStepsBonuses, credentials, param) {
  return {
          email: email,
          inviteToken: inviteToken,
          role: role,
          active: active,
          failures: failures,
          authoredSmartcuts: authoredSmartcuts,
          topSites: topSites,
          installedSmartcuts: installedSmartcuts,
          scheduledTriggers: scheduledTriggers,
          build: build,
          subscriptions: subscriptions,
          userFlags: userFlags,
          finishedOnboarding: finishedOnboarding,
          completedExtraStepsBonuses: completedExtraStepsBonuses,
          credentials: credentials
        };
}

function makeInputObjectUserAuthoredSmartcutsRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectSmartcutInput(author, name, description, visibility, schemaVersion, currentRevision, startingUrlPattern, maybeRedirectedFromUrlPatterns, numCommands, origins, screens, recordedSmartcut, smartcutParams, stepDescriptions, msBeforeNextCommand, defaultPlaybackOptionsSerialized, playbackOptionsSchemaVersion, topic, priorityInTopic, maybeMsBeforeCloseWindow, loginUrls, loginSmartcutRefsSerialized, param) {
  return {
          author: author,
          name: name,
          description: description,
          visibility: visibility,
          schemaVersion: schemaVersion,
          currentRevision: currentRevision,
          startingUrlPattern: startingUrlPattern,
          maybeRedirectedFromUrlPatterns: maybeRedirectedFromUrlPatterns,
          numCommands: numCommands,
          origins: origins,
          screens: screens,
          recordedSmartcut: recordedSmartcut,
          smartcutParams: smartcutParams,
          stepDescriptions: stepDescriptions,
          msBeforeNextCommand: msBeforeNextCommand,
          defaultPlaybackOptionsSerialized: defaultPlaybackOptionsSerialized,
          playbackOptionsSchemaVersion: playbackOptionsSchemaVersion,
          topic: topic,
          priorityInTopic: priorityInTopic,
          maybeMsBeforeCloseWindow: maybeMsBeforeCloseWindow,
          loginUrls: loginUrls,
          loginSmartcutRefsSerialized: loginSmartcutRefsSerialized
        };
}

function makeInputObjectSmartcutAuthorRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectScreenInput(ikId, url, param) {
  return {
          ikId: ikId,
          url: url
        };
}

function makeInputObjectSmartcutRecordedSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectRecordedSmartcutInput(author, name, description, startingUrlPattern, origins, screens, schemaVersion, commandLog, recordingCommandLog, authoringCommandLog, numCommands, numRecordingCommands, numAuthoringCommands, commandsSize, recordingCommandsSize, authoringCommandsSize, smartcutRevision, smartcut, recordingStartedAt, recordingEndedAt, param) {
  return {
          author: author,
          name: name,
          description: description,
          startingUrlPattern: startingUrlPattern,
          origins: origins,
          screens: screens,
          schemaVersion: schemaVersion,
          commandLog: commandLog,
          recordingCommandLog: recordingCommandLog,
          authoringCommandLog: authoringCommandLog,
          numCommands: numCommands,
          numRecordingCommands: numRecordingCommands,
          numAuthoringCommands: numAuthoringCommands,
          commandsSize: commandsSize,
          recordingCommandsSize: recordingCommandsSize,
          authoringCommandsSize: authoringCommandsSize,
          smartcutRevision: smartcutRevision,
          smartcut: smartcut,
          recordingStartedAt: recordingStartedAt,
          recordingEndedAt: recordingEndedAt
        };
}

function makeInputObjectRecordedSmartcutAuthorRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectRecordedSmartcutCommandLogRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectMainCommandLogEntryInput(recordedSmartcut, index, commandSerialized, contextSerialized, schemaVersion, size, dextSchemaVersion, param) {
  return {
          recordedSmartcut: recordedSmartcut,
          index: index,
          commandSerialized: commandSerialized,
          contextSerialized: contextSerialized,
          schemaVersion: schemaVersion,
          size: size,
          dextSchemaVersion: dextSchemaVersion
        };
}

function makeInputObjectMainCommandLogEntryRecordedSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectRecordedSmartcutRecordingCommandLogRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectRecordingCommandLogEntryInput(recordedSmartcut, index, commandSerialized, contextSerialized, schemaVersion, size, dextSchemaVersion, param) {
  return {
          recordedSmartcut: recordedSmartcut,
          index: index,
          commandSerialized: commandSerialized,
          contextSerialized: contextSerialized,
          schemaVersion: schemaVersion,
          size: size,
          dextSchemaVersion: dextSchemaVersion
        };
}

function makeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectRecordedSmartcutAuthoringCommandLogRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectAuthoringCommandLogEntryInput(recordedSmartcut, index, commandSerialized, contextSerialized, schemaVersion, size, dextSchemaVersion, param) {
  return {
          recordedSmartcut: recordedSmartcut,
          index: index,
          commandSerialized: commandSerialized,
          contextSerialized: contextSerialized,
          schemaVersion: schemaVersion,
          size: size,
          dextSchemaVersion: dextSchemaVersion
        };
}

function makeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectRecordedSmartcutSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectSmartcutParamInput(firstCommandIndex, otherCommandIndexes, param, param$1) {
  return {
          firstCommandIndex: firstCommandIndex,
          otherCommandIndexes: otherCommandIndexes,
          param: param
        };
}

function makeInputObjectUrlWithTitleInput(url, title, param) {
  return {
          url: url,
          title: title
        };
}

function makeInputObjectUserInstalledSmartcutsRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectInstalledSmartcutInput(owner, schemaVersion, smartcut, smartcutRevision, recordedSmartcut, smartcutParamDefaults, scheduledTriggers, defaultPlaybackOptionsSerialized, playbackOptionsSchemaVersion, param) {
  return {
          owner: owner,
          schemaVersion: schemaVersion,
          smartcut: smartcut,
          smartcutRevision: smartcutRevision,
          recordedSmartcut: recordedSmartcut,
          smartcutParamDefaults: smartcutParamDefaults,
          scheduledTriggers: scheduledTriggers,
          defaultPlaybackOptionsSerialized: defaultPlaybackOptionsSerialized,
          playbackOptionsSchemaVersion: playbackOptionsSchemaVersion
        };
}

function makeInputObjectInstalledSmartcutOwnerRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectInstalledSmartcutSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectInstalledSmartcutRecordedSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectInstalledSmartcutScheduledTriggersRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectScheduledTriggerInput(smartcut, user, status, schedulePeriodSerialized, dataSourceSerialized, playbackOptionsSerialized, commandSchemaVersion, playbackOptionsSchemaVersion, maybeLastCheckedAt, param) {
  return {
          smartcut: smartcut,
          user: user,
          status: status,
          schedulePeriodSerialized: schedulePeriodSerialized,
          dataSourceSerialized: dataSourceSerialized,
          playbackOptionsSerialized: playbackOptionsSerialized,
          commandSchemaVersion: commandSchemaVersion,
          playbackOptionsSchemaVersion: playbackOptionsSchemaVersion,
          maybeLastCheckedAt: maybeLastCheckedAt
        };
}

function makeInputObjectScheduledTriggerSmartcutRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectScheduledTriggerUserRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectUserScheduledTriggersRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectUserSubscriptionsRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectPlanSubscriptionInput(customer, servicePlan, remainingExecutions, remainingExecutionSteps, expirationDate, autoRenewal, subtotal, stripeCustomerId, param) {
  return {
          customer: customer,
          servicePlan: servicePlan,
          remainingExecutions: remainingExecutions,
          remainingExecutionSteps: remainingExecutionSteps,
          expirationDate: expirationDate,
          autoRenewal: autoRenewal,
          subtotal: subtotal,
          stripeCustomerId: stripeCustomerId
        };
}

function makeInputObjectPlanSubscriptionCustomerRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectPlanSubscriptionServicePlanRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectServicePlanInput(name, description, executionLimits, executionSteps, subscriptionPrice, param) {
  return {
          name: name,
          description: description,
          executionLimits: executionLimits,
          executionSteps: executionSteps,
          subscriptionPrice: subscriptionPrice
        };
}

function makeInputObjectUserCredentialsRelation(create, connect, disconnect, param) {
  return {
          create: create,
          connect: connect,
          disconnect: disconnect
        };
}

function makeInputObjectUserCredentialEntryInput(user, hostname, credentialSchemaVersion, credentialSerialized, param) {
  return {
          user: user,
          hostname: hostname,
          credentialSchemaVersion: credentialSchemaVersion,
          credentialSerialized: credentialSerialized
        };
}

function makeInputObjectUserCredentialEntryUserRelation(create, connect, param) {
  return {
          create: create,
          connect: connect
        };
}

function makeInputObjectPartialUpdateUrlWithTitleInput(url, title, param) {
  return {
          url: url,
          title: title
        };
}

var UpdateUserQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectPartialUpdateUserInput: serializeInputObjectPartialUpdateUserInput,
  serializeInputObjectUserFailuresRelation: serializeInputObjectUserFailuresRelation,
  serializeInputObjectFailureInput: serializeInputObjectFailureInput,
  serializeInputObjectFailureUserRelation: serializeInputObjectFailureUserRelation,
  serializeInputObjectUserInput: serializeInputObjectUserInput,
  serializeInputObjectUserAuthoredSmartcutsRelation: serializeInputObjectUserAuthoredSmartcutsRelation,
  serializeInputObjectSmartcutInput: serializeInputObjectSmartcutInput,
  serializeInputObjectSmartcutAuthorRelation: serializeInputObjectSmartcutAuthorRelation,
  serializeInputObjectScreenInput: serializeInputObjectScreenInput,
  serializeInputObjectSmartcutRecordedSmartcutRelation: serializeInputObjectSmartcutRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutInput: serializeInputObjectRecordedSmartcutInput,
  serializeInputObjectRecordedSmartcutAuthorRelation: serializeInputObjectRecordedSmartcutAuthorRelation,
  serializeInputObjectRecordedSmartcutCommandLogRelation: serializeInputObjectRecordedSmartcutCommandLogRelation,
  serializeInputObjectMainCommandLogEntryInput: serializeInputObjectMainCommandLogEntryInput,
  serializeInputObjectMainCommandLogEntryRecordedSmartcutRelation: serializeInputObjectMainCommandLogEntryRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutRecordingCommandLogRelation: serializeInputObjectRecordedSmartcutRecordingCommandLogRelation,
  serializeInputObjectRecordingCommandLogEntryInput: serializeInputObjectRecordingCommandLogEntryInput,
  serializeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation: serializeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutAuthoringCommandLogRelation: serializeInputObjectRecordedSmartcutAuthoringCommandLogRelation,
  serializeInputObjectAuthoringCommandLogEntryInput: serializeInputObjectAuthoringCommandLogEntryInput,
  serializeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation: serializeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutSmartcutRelation: serializeInputObjectRecordedSmartcutSmartcutRelation,
  serializeInputObjectSmartcutParamInput: serializeInputObjectSmartcutParamInput,
  serializeInputObjectUrlWithTitleInput: serializeInputObjectUrlWithTitleInput,
  serializeInputObjectUserInstalledSmartcutsRelation: serializeInputObjectUserInstalledSmartcutsRelation,
  serializeInputObjectInstalledSmartcutInput: serializeInputObjectInstalledSmartcutInput,
  serializeInputObjectInstalledSmartcutOwnerRelation: serializeInputObjectInstalledSmartcutOwnerRelation,
  serializeInputObjectInstalledSmartcutSmartcutRelation: serializeInputObjectInstalledSmartcutSmartcutRelation,
  serializeInputObjectInstalledSmartcutRecordedSmartcutRelation: serializeInputObjectInstalledSmartcutRecordedSmartcutRelation,
  serializeInputObjectInstalledSmartcutScheduledTriggersRelation: serializeInputObjectInstalledSmartcutScheduledTriggersRelation,
  serializeInputObjectScheduledTriggerInput: serializeInputObjectScheduledTriggerInput,
  serializeInputObjectScheduledTriggerSmartcutRelation: serializeInputObjectScheduledTriggerSmartcutRelation,
  serializeInputObjectScheduledTriggerUserRelation: serializeInputObjectScheduledTriggerUserRelation,
  serializeInputObjectUserScheduledTriggersRelation: serializeInputObjectUserScheduledTriggersRelation,
  serializeInputObjectUserSubscriptionsRelation: serializeInputObjectUserSubscriptionsRelation,
  serializeInputObjectPlanSubscriptionInput: serializeInputObjectPlanSubscriptionInput,
  serializeInputObjectPlanSubscriptionCustomerRelation: serializeInputObjectPlanSubscriptionCustomerRelation,
  serializeInputObjectPlanSubscriptionServicePlanRelation: serializeInputObjectPlanSubscriptionServicePlanRelation,
  serializeInputObjectServicePlanInput: serializeInputObjectServicePlanInput,
  serializeInputObjectUserCredentialsRelation: serializeInputObjectUserCredentialsRelation,
  serializeInputObjectUserCredentialEntryInput: serializeInputObjectUserCredentialEntryInput,
  serializeInputObjectUserCredentialEntryUserRelation: serializeInputObjectUserCredentialEntryUserRelation,
  serializeInputObjectPartialUpdateUrlWithTitleInput: serializeInputObjectPartialUpdateUrlWithTitleInput,
  makeVariables: makeVariables$1,
  makeInputObjectPartialUpdateUserInput: makeInputObjectPartialUpdateUserInput,
  makeInputObjectUserFailuresRelation: makeInputObjectUserFailuresRelation,
  makeInputObjectFailureInput: makeInputObjectFailureInput,
  makeInputObjectFailureUserRelation: makeInputObjectFailureUserRelation,
  makeInputObjectUserInput: makeInputObjectUserInput,
  makeInputObjectUserAuthoredSmartcutsRelation: makeInputObjectUserAuthoredSmartcutsRelation,
  makeInputObjectSmartcutInput: makeInputObjectSmartcutInput,
  makeInputObjectSmartcutAuthorRelation: makeInputObjectSmartcutAuthorRelation,
  makeInputObjectScreenInput: makeInputObjectScreenInput,
  makeInputObjectSmartcutRecordedSmartcutRelation: makeInputObjectSmartcutRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutInput: makeInputObjectRecordedSmartcutInput,
  makeInputObjectRecordedSmartcutAuthorRelation: makeInputObjectRecordedSmartcutAuthorRelation,
  makeInputObjectRecordedSmartcutCommandLogRelation: makeInputObjectRecordedSmartcutCommandLogRelation,
  makeInputObjectMainCommandLogEntryInput: makeInputObjectMainCommandLogEntryInput,
  makeInputObjectMainCommandLogEntryRecordedSmartcutRelation: makeInputObjectMainCommandLogEntryRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutRecordingCommandLogRelation: makeInputObjectRecordedSmartcutRecordingCommandLogRelation,
  makeInputObjectRecordingCommandLogEntryInput: makeInputObjectRecordingCommandLogEntryInput,
  makeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation: makeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutAuthoringCommandLogRelation: makeInputObjectRecordedSmartcutAuthoringCommandLogRelation,
  makeInputObjectAuthoringCommandLogEntryInput: makeInputObjectAuthoringCommandLogEntryInput,
  makeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation: makeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutSmartcutRelation: makeInputObjectRecordedSmartcutSmartcutRelation,
  makeInputObjectSmartcutParamInput: makeInputObjectSmartcutParamInput,
  makeInputObjectUrlWithTitleInput: makeInputObjectUrlWithTitleInput,
  makeInputObjectUserInstalledSmartcutsRelation: makeInputObjectUserInstalledSmartcutsRelation,
  makeInputObjectInstalledSmartcutInput: makeInputObjectInstalledSmartcutInput,
  makeInputObjectInstalledSmartcutOwnerRelation: makeInputObjectInstalledSmartcutOwnerRelation,
  makeInputObjectInstalledSmartcutSmartcutRelation: makeInputObjectInstalledSmartcutSmartcutRelation,
  makeInputObjectInstalledSmartcutRecordedSmartcutRelation: makeInputObjectInstalledSmartcutRecordedSmartcutRelation,
  makeInputObjectInstalledSmartcutScheduledTriggersRelation: makeInputObjectInstalledSmartcutScheduledTriggersRelation,
  makeInputObjectScheduledTriggerInput: makeInputObjectScheduledTriggerInput,
  makeInputObjectScheduledTriggerSmartcutRelation: makeInputObjectScheduledTriggerSmartcutRelation,
  makeInputObjectScheduledTriggerUserRelation: makeInputObjectScheduledTriggerUserRelation,
  makeInputObjectUserScheduledTriggersRelation: makeInputObjectUserScheduledTriggersRelation,
  makeInputObjectUserSubscriptionsRelation: makeInputObjectUserSubscriptionsRelation,
  makeInputObjectPlanSubscriptionInput: makeInputObjectPlanSubscriptionInput,
  makeInputObjectPlanSubscriptionCustomerRelation: makeInputObjectPlanSubscriptionCustomerRelation,
  makeInputObjectPlanSubscriptionServicePlanRelation: makeInputObjectPlanSubscriptionServicePlanRelation,
  makeInputObjectServicePlanInput: makeInputObjectServicePlanInput,
  makeInputObjectUserCredentialsRelation: makeInputObjectUserCredentialsRelation,
  makeInputObjectUserCredentialEntryInput: makeInputObjectUserCredentialEntryInput,
  makeInputObjectUserCredentialEntryUserRelation: makeInputObjectUserCredentialEntryUserRelation,
  makeInputObjectPartialUpdateUrlWithTitleInput: makeInputObjectPartialUpdateUrlWithTitleInput
};

var include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var UpdateUserQuery_use = include$1.use;

var UpdateUserQuery_useWithVariables = include$1.useWithVariables;

var UpdateUserQuery = {
  UpdateUserQuery_inner: UpdateUserQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectPartialUpdateUserInput: serializeInputObjectPartialUpdateUserInput,
  serializeInputObjectUserFailuresRelation: serializeInputObjectUserFailuresRelation,
  serializeInputObjectFailureInput: serializeInputObjectFailureInput,
  serializeInputObjectFailureUserRelation: serializeInputObjectFailureUserRelation,
  serializeInputObjectUserInput: serializeInputObjectUserInput,
  serializeInputObjectUserAuthoredSmartcutsRelation: serializeInputObjectUserAuthoredSmartcutsRelation,
  serializeInputObjectSmartcutInput: serializeInputObjectSmartcutInput,
  serializeInputObjectSmartcutAuthorRelation: serializeInputObjectSmartcutAuthorRelation,
  serializeInputObjectScreenInput: serializeInputObjectScreenInput,
  serializeInputObjectSmartcutRecordedSmartcutRelation: serializeInputObjectSmartcutRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutInput: serializeInputObjectRecordedSmartcutInput,
  serializeInputObjectRecordedSmartcutAuthorRelation: serializeInputObjectRecordedSmartcutAuthorRelation,
  serializeInputObjectRecordedSmartcutCommandLogRelation: serializeInputObjectRecordedSmartcutCommandLogRelation,
  serializeInputObjectMainCommandLogEntryInput: serializeInputObjectMainCommandLogEntryInput,
  serializeInputObjectMainCommandLogEntryRecordedSmartcutRelation: serializeInputObjectMainCommandLogEntryRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutRecordingCommandLogRelation: serializeInputObjectRecordedSmartcutRecordingCommandLogRelation,
  serializeInputObjectRecordingCommandLogEntryInput: serializeInputObjectRecordingCommandLogEntryInput,
  serializeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation: serializeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutAuthoringCommandLogRelation: serializeInputObjectRecordedSmartcutAuthoringCommandLogRelation,
  serializeInputObjectAuthoringCommandLogEntryInput: serializeInputObjectAuthoringCommandLogEntryInput,
  serializeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation: serializeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation,
  serializeInputObjectRecordedSmartcutSmartcutRelation: serializeInputObjectRecordedSmartcutSmartcutRelation,
  serializeInputObjectSmartcutParamInput: serializeInputObjectSmartcutParamInput,
  serializeInputObjectUrlWithTitleInput: serializeInputObjectUrlWithTitleInput,
  serializeInputObjectUserInstalledSmartcutsRelation: serializeInputObjectUserInstalledSmartcutsRelation,
  serializeInputObjectInstalledSmartcutInput: serializeInputObjectInstalledSmartcutInput,
  serializeInputObjectInstalledSmartcutOwnerRelation: serializeInputObjectInstalledSmartcutOwnerRelation,
  serializeInputObjectInstalledSmartcutSmartcutRelation: serializeInputObjectInstalledSmartcutSmartcutRelation,
  serializeInputObjectInstalledSmartcutRecordedSmartcutRelation: serializeInputObjectInstalledSmartcutRecordedSmartcutRelation,
  serializeInputObjectInstalledSmartcutScheduledTriggersRelation: serializeInputObjectInstalledSmartcutScheduledTriggersRelation,
  serializeInputObjectScheduledTriggerInput: serializeInputObjectScheduledTriggerInput,
  serializeInputObjectScheduledTriggerSmartcutRelation: serializeInputObjectScheduledTriggerSmartcutRelation,
  serializeInputObjectScheduledTriggerUserRelation: serializeInputObjectScheduledTriggerUserRelation,
  serializeInputObjectUserScheduledTriggersRelation: serializeInputObjectUserScheduledTriggersRelation,
  serializeInputObjectUserSubscriptionsRelation: serializeInputObjectUserSubscriptionsRelation,
  serializeInputObjectPlanSubscriptionInput: serializeInputObjectPlanSubscriptionInput,
  serializeInputObjectPlanSubscriptionCustomerRelation: serializeInputObjectPlanSubscriptionCustomerRelation,
  serializeInputObjectPlanSubscriptionServicePlanRelation: serializeInputObjectPlanSubscriptionServicePlanRelation,
  serializeInputObjectServicePlanInput: serializeInputObjectServicePlanInput,
  serializeInputObjectUserCredentialsRelation: serializeInputObjectUserCredentialsRelation,
  serializeInputObjectUserCredentialEntryInput: serializeInputObjectUserCredentialEntryInput,
  serializeInputObjectUserCredentialEntryUserRelation: serializeInputObjectUserCredentialEntryUserRelation,
  serializeInputObjectPartialUpdateUrlWithTitleInput: serializeInputObjectPartialUpdateUrlWithTitleInput,
  makeVariables: makeVariables$1,
  makeInputObjectPartialUpdateUserInput: makeInputObjectPartialUpdateUserInput,
  makeInputObjectUserFailuresRelation: makeInputObjectUserFailuresRelation,
  makeInputObjectFailureInput: makeInputObjectFailureInput,
  makeInputObjectFailureUserRelation: makeInputObjectFailureUserRelation,
  makeInputObjectUserInput: makeInputObjectUserInput,
  makeInputObjectUserAuthoredSmartcutsRelation: makeInputObjectUserAuthoredSmartcutsRelation,
  makeInputObjectSmartcutInput: makeInputObjectSmartcutInput,
  makeInputObjectSmartcutAuthorRelation: makeInputObjectSmartcutAuthorRelation,
  makeInputObjectScreenInput: makeInputObjectScreenInput,
  makeInputObjectSmartcutRecordedSmartcutRelation: makeInputObjectSmartcutRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutInput: makeInputObjectRecordedSmartcutInput,
  makeInputObjectRecordedSmartcutAuthorRelation: makeInputObjectRecordedSmartcutAuthorRelation,
  makeInputObjectRecordedSmartcutCommandLogRelation: makeInputObjectRecordedSmartcutCommandLogRelation,
  makeInputObjectMainCommandLogEntryInput: makeInputObjectMainCommandLogEntryInput,
  makeInputObjectMainCommandLogEntryRecordedSmartcutRelation: makeInputObjectMainCommandLogEntryRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutRecordingCommandLogRelation: makeInputObjectRecordedSmartcutRecordingCommandLogRelation,
  makeInputObjectRecordingCommandLogEntryInput: makeInputObjectRecordingCommandLogEntryInput,
  makeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation: makeInputObjectRecordingCommandLogEntryRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutAuthoringCommandLogRelation: makeInputObjectRecordedSmartcutAuthoringCommandLogRelation,
  makeInputObjectAuthoringCommandLogEntryInput: makeInputObjectAuthoringCommandLogEntryInput,
  makeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation: makeInputObjectAuthoringCommandLogEntryRecordedSmartcutRelation,
  makeInputObjectRecordedSmartcutSmartcutRelation: makeInputObjectRecordedSmartcutSmartcutRelation,
  makeInputObjectSmartcutParamInput: makeInputObjectSmartcutParamInput,
  makeInputObjectUrlWithTitleInput: makeInputObjectUrlWithTitleInput,
  makeInputObjectUserInstalledSmartcutsRelation: makeInputObjectUserInstalledSmartcutsRelation,
  makeInputObjectInstalledSmartcutInput: makeInputObjectInstalledSmartcutInput,
  makeInputObjectInstalledSmartcutOwnerRelation: makeInputObjectInstalledSmartcutOwnerRelation,
  makeInputObjectInstalledSmartcutSmartcutRelation: makeInputObjectInstalledSmartcutSmartcutRelation,
  makeInputObjectInstalledSmartcutRecordedSmartcutRelation: makeInputObjectInstalledSmartcutRecordedSmartcutRelation,
  makeInputObjectInstalledSmartcutScheduledTriggersRelation: makeInputObjectInstalledSmartcutScheduledTriggersRelation,
  makeInputObjectScheduledTriggerInput: makeInputObjectScheduledTriggerInput,
  makeInputObjectScheduledTriggerSmartcutRelation: makeInputObjectScheduledTriggerSmartcutRelation,
  makeInputObjectScheduledTriggerUserRelation: makeInputObjectScheduledTriggerUserRelation,
  makeInputObjectUserScheduledTriggersRelation: makeInputObjectUserScheduledTriggersRelation,
  makeInputObjectUserSubscriptionsRelation: makeInputObjectUserSubscriptionsRelation,
  makeInputObjectPlanSubscriptionInput: makeInputObjectPlanSubscriptionInput,
  makeInputObjectPlanSubscriptionCustomerRelation: makeInputObjectPlanSubscriptionCustomerRelation,
  makeInputObjectPlanSubscriptionServicePlanRelation: makeInputObjectPlanSubscriptionServicePlanRelation,
  makeInputObjectServicePlanInput: makeInputObjectServicePlanInput,
  makeInputObjectUserCredentialsRelation: makeInputObjectUserCredentialsRelation,
  makeInputObjectUserCredentialEntryInput: makeInputObjectUserCredentialEntryInput,
  makeInputObjectUserCredentialEntryUserRelation: makeInputObjectUserCredentialEntryUserRelation,
  makeInputObjectPartialUpdateUrlWithTitleInput: makeInputObjectPartialUpdateUrlWithTitleInput,
  use: UpdateUserQuery_use,
  useWithVariables: UpdateUserQuery_useWithVariables
};

var Raw$2 = {};

var query$2 = (require("@apollo/client").gql`
  query   {
    myActiveSubscriptions  {
      __typename
      data  {
        __typename
        _id
        remainingExecutionSteps
        expirationDate
        subtotal
        servicePlan  {
          __typename
          _id
          name
          subscriptionPrice
          executionSteps
        }
        stripeCustomerId
      }
    }
  }
`);

function parse$2(value) {
  var value$1 = value.myActiveSubscriptions;
  var value$2 = value$1.data;
  return {
          myActiveSubscriptions: {
            __typename: value$1.__typename,
            data: value$2.map(function (value) {
                  if (value == null) {
                    return ;
                  }
                  var value$1 = value.subtotal;
                  var value$2 = value.servicePlan;
                  var value$3 = value.stripeCustomerId;
                  return {
                          __typename: value.__typename,
                          _id: value._id,
                          remainingExecutionSteps: value.remainingExecutionSteps,
                          expirationDate: value.expirationDate,
                          subtotal: !(value$1 == null) ? value$1 : undefined,
                          servicePlan: {
                            __typename: value$2.__typename,
                            _id: value$2._id,
                            name: value$2.name,
                            subscriptionPrice: value$2.subscriptionPrice,
                            executionSteps: value$2.executionSteps
                          },
                          stripeCustomerId: !(value$3 == null) ? value$3 : undefined
                        };
                })
          }
        };
}

function serialize$2(value) {
  var value$1 = value.myActiveSubscriptions;
  var value$2 = value$1.data;
  var data = value$2.map(function (value) {
        if (value === undefined) {
          return null;
        }
        var value$1 = value.stripeCustomerId;
        var stripeCustomerId = value$1 !== undefined ? value$1 : null;
        var value$2 = value.servicePlan;
        var value$3 = value$2.executionSteps;
        var value$4 = value$2.subscriptionPrice;
        var value$5 = value$2.name;
        var value$6 = value$2._id;
        var value$7 = value$2.__typename;
        var servicePlan = {
          __typename: value$7,
          _id: value$6,
          name: value$5,
          subscriptionPrice: value$4,
          executionSteps: value$3
        };
        var value$8 = value.subtotal;
        var subtotal = value$8 !== undefined ? value$8 : null;
        var value$9 = value.expirationDate;
        var value$10 = value.remainingExecutionSteps;
        var value$11 = value._id;
        var value$12 = value.__typename;
        return {
                __typename: value$12,
                _id: value$11,
                remainingExecutionSteps: value$10,
                expirationDate: value$9,
                subtotal: subtotal,
                servicePlan: servicePlan,
                stripeCustomerId: stripeCustomerId
              };
      });
  var value$3 = value$1.__typename;
  var myActiveSubscriptions = {
    __typename: value$3,
    data: data
  };
  return {
          myActiveSubscriptions: myActiveSubscriptions
        };
}

function serializeVariables$2(param) {
  
}

function makeVariables$2(param) {
  
}

function makeDefaultVariables(param) {
  
}

var MyActiveSubscriptions_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  makeDefaultVariables: makeDefaultVariables
};

var include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$2,
      Raw: Raw$2,
      parse: parse$2,
      serialize: serialize$2,
      serializeVariables: serializeVariables$2
    });

var MyActiveSubscriptions_refetchQueryDescription = include$2.refetchQueryDescription;

var MyActiveSubscriptions_use = include$2.use;

var MyActiveSubscriptions_useLazy = include$2.useLazy;

var MyActiveSubscriptions_useLazyWithVariables = include$2.useLazyWithVariables;

var MyActiveSubscriptions = {
  MyActiveSubscriptions_inner: MyActiveSubscriptions_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: MyActiveSubscriptions_refetchQueryDescription,
  use: MyActiveSubscriptions_use,
  useLazy: MyActiveSubscriptions_useLazy,
  useLazyWithVariables: MyActiveSubscriptions_useLazyWithVariables
};

var Raw$3 = {};

var query$3 = (require("@apollo/client").gql`
  mutation ($subscriptionId: ID!, $numExecutionSteps: Int!)  {
    consumeSubscription(subscriptionId: $subscriptionId, numExecutionSteps: $numExecutionSteps)  {
      __typename
      remainingExecutionSteps
    }
  }
`);

function parse$3(value) {
  var value$1 = value.consumeSubscription;
  return {
          consumeSubscription: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                remainingExecutionSteps: value$1.remainingExecutionSteps
              }) : undefined
        };
}

function serialize$3(value) {
  var value$1 = value.consumeSubscription;
  var consumeSubscription;
  if (value$1 !== undefined) {
    var value$2 = value$1.remainingExecutionSteps;
    var value$3 = value$1.__typename;
    consumeSubscription = {
      __typename: value$3,
      remainingExecutionSteps: value$2
    };
  } else {
    consumeSubscription = null;
  }
  return {
          consumeSubscription: consumeSubscription
        };
}

function serializeVariables$3(inp) {
  return {
          subscriptionId: inp.subscriptionId,
          numExecutionSteps: inp.numExecutionSteps
        };
}

function makeVariables$3(subscriptionId, numExecutionSteps, param) {
  return {
          subscriptionId: subscriptionId,
          numExecutionSteps: numExecutionSteps
        };
}

var ConsumeSubscription_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};

var include$3 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$3,
      Raw: Raw$3,
      parse: parse$3,
      serialize: serialize$3,
      serializeVariables: serializeVariables$3
    });

var ConsumeSubscription_use = include$3.use;

var ConsumeSubscription_useWithVariables = include$3.useWithVariables;

var ConsumeSubscription = {
  ConsumeSubscription_inner: ConsumeSubscription_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  use: ConsumeSubscription_use,
  useWithVariables: ConsumeSubscription_useWithVariables
};

var Raw$4 = {};

var query$4 = (require("@apollo/client").gql`
  query   {
    allServicePlans  {
      __typename
      data  {
        __typename
        _id
        name
        description
        executionSteps
        subscriptionPrice
      }
    }
  }
`);

function parse$4(value) {
  var value$1 = value.allServicePlans;
  var value$2 = value$1.data;
  return {
          allServicePlans: {
            __typename: value$1.__typename,
            data: value$2.map(function (value) {
                  if (!(value == null)) {
                    return {
                            __typename: value.__typename,
                            _id: value._id,
                            name: value.name,
                            description: value.description,
                            executionSteps: value.executionSteps,
                            subscriptionPrice: value.subscriptionPrice
                          };
                  }
                  
                })
          }
        };
}

function serialize$4(value) {
  var value$1 = value.allServicePlans;
  var value$2 = value$1.data;
  var data = value$2.map(function (value) {
        if (value === undefined) {
          return null;
        }
        var value$1 = value.subscriptionPrice;
        var value$2 = value.executionSteps;
        var value$3 = value.description;
        var value$4 = value.name;
        var value$5 = value._id;
        var value$6 = value.__typename;
        return {
                __typename: value$6,
                _id: value$5,
                name: value$4,
                description: value$3,
                executionSteps: value$2,
                subscriptionPrice: value$1
              };
      });
  var value$3 = value$1.__typename;
  var allServicePlans = {
    __typename: value$3,
    data: data
  };
  return {
          allServicePlans: allServicePlans
        };
}

function serializeVariables$4(param) {
  
}

function makeVariables$4(param) {
  
}

function makeDefaultVariables$1(param) {
  
}

var AllServicePlans_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  makeDefaultVariables: makeDefaultVariables$1
};

var include$4 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$4,
      Raw: Raw$4,
      parse: parse$4,
      serialize: serialize$4,
      serializeVariables: serializeVariables$4
    });

var AllServicePlans_refetchQueryDescription = include$4.refetchQueryDescription;

var AllServicePlans_use = include$4.use;

var AllServicePlans_useLazy = include$4.useLazy;

var AllServicePlans_useLazyWithVariables = include$4.useLazyWithVariables;

var AllServicePlans = {
  AllServicePlans_inner: AllServicePlans_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: AllServicePlans_refetchQueryDescription,
  use: AllServicePlans_use,
  useLazy: AllServicePlans_useLazy,
  useLazyWithVariables: AllServicePlans_useLazyWithVariables
};

var Raw$5 = {};

var query$5 = (require("@apollo/client").gql`
  mutation ($customerId: ID!, $servicePlanId: ID!)  {
    createSubscription(customerId: $customerId, servicePlanId: $servicePlanId)  {
      __typename
      _id
      remainingExecutionSteps
      expirationDate
      subtotal
      servicePlan  {
        __typename
        _id
        name
        subscriptionPrice
        executionSteps
      }
      stripeCustomerId
    }
  }
`);

function parse$5(value) {
  var value$1 = value.createSubscription;
  var value$2 = value$1.subtotal;
  var value$3 = value$1.servicePlan;
  var value$4 = value$1.stripeCustomerId;
  return {
          createSubscription: {
            __typename: value$1.__typename,
            _id: value$1._id,
            remainingExecutionSteps: value$1.remainingExecutionSteps,
            expirationDate: value$1.expirationDate,
            subtotal: !(value$2 == null) ? value$2 : undefined,
            servicePlan: {
              __typename: value$3.__typename,
              _id: value$3._id,
              name: value$3.name,
              subscriptionPrice: value$3.subscriptionPrice,
              executionSteps: value$3.executionSteps
            },
            stripeCustomerId: !(value$4 == null) ? value$4 : undefined
          }
        };
}

function serialize$5(value) {
  var value$1 = value.createSubscription;
  var value$2 = value$1.stripeCustomerId;
  var stripeCustomerId = value$2 !== undefined ? value$2 : null;
  var value$3 = value$1.servicePlan;
  var value$4 = value$3.executionSteps;
  var value$5 = value$3.subscriptionPrice;
  var value$6 = value$3.name;
  var value$7 = value$3._id;
  var value$8 = value$3.__typename;
  var servicePlan = {
    __typename: value$8,
    _id: value$7,
    name: value$6,
    subscriptionPrice: value$5,
    executionSteps: value$4
  };
  var value$9 = value$1.subtotal;
  var subtotal = value$9 !== undefined ? value$9 : null;
  var value$10 = value$1.expirationDate;
  var value$11 = value$1.remainingExecutionSteps;
  var value$12 = value$1._id;
  var value$13 = value$1.__typename;
  var createSubscription = {
    __typename: value$13,
    _id: value$12,
    remainingExecutionSteps: value$11,
    expirationDate: value$10,
    subtotal: subtotal,
    servicePlan: servicePlan,
    stripeCustomerId: stripeCustomerId
  };
  return {
          createSubscription: createSubscription
        };
}

function serializeVariables$5(inp) {
  return {
          customerId: inp.customerId,
          servicePlanId: inp.servicePlanId
        };
}

function makeVariables$5(customerId, servicePlanId, param) {
  return {
          customerId: customerId,
          servicePlanId: servicePlanId
        };
}

var SubscribeUserToServicePlan_inner = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5
};

var include$5 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$5,
      Raw: Raw$5,
      parse: parse$5,
      serialize: serialize$5,
      serializeVariables: serializeVariables$5
    });

var SubscribeUserToServicePlan_use = include$5.use;

var SubscribeUserToServicePlan_useWithVariables = include$5.useWithVariables;

var SubscribeUserToServicePlan = {
  SubscribeUserToServicePlan_inner: SubscribeUserToServicePlan_inner,
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5,
  use: SubscribeUserToServicePlan_use,
  useWithVariables: SubscribeUserToServicePlan_useWithVariables
};

function createNewUserWithFreeSubscription(token, userRoleOpt, email, build, param) {
  var userRole = userRoleOpt !== undefined ? userRoleOpt : "CUSTOMER";
  var inviteToken = Uuid.v1();
  var client = Apollo$SmartcutsMacros.makeClient(undefined, token, undefined);
  var createUserPromise = Curry.app(client.rescript_mutate, [
        {
          query: query,
          Raw: Raw,
          parse: parse,
          serialize: serialize,
          serializeVariables: serializeVariables
        },
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        {
          user: {
            email: email,
            password: inviteToken,
            role: userRole,
            active: false,
            inviteToken: inviteToken,
            build: build
          }
        }
      ]);
  var allServicePlansPromise = Curry._6(client.rescript_query, {
        query: query$4,
        Raw: Raw$4,
        parse: parse$4,
        serialize: serialize$4,
        serializeVariables: serializeVariables$4
      }, undefined, undefined, undefined, undefined, undefined);
  return Promise.all([
                createUserPromise,
                allServicePlansPromise
              ]).then(function (param) {
              var servicePlansResponse = param[1];
              var userResponse = param[0];
              if (userResponse.TAG === /* Ok */0) {
                if (servicePlansResponse.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: Belt_MapString.fromArray([[
                                      "AllServicePlans",
                                      servicePlansResponse._0
                                    ]])
                            });
                }
                var userId = userResponse._0.data.createUser._id;
                var arg = servicePlansResponse._0.data.allServicePlans.data;
                var arg$1 = (function (param) {
                      return ArrayUtils$SmartcutsMacros.shortcut(param, arg);
                    })(function (maybeServicePlan) {
                      return Belt_Option.flatMap(maybeServicePlan, (function (servicePlan) {
                                    if (servicePlan.subscriptionPrice === 0) {
                                      return servicePlan._id;
                                    }
                                    
                                  }));
                    });
                var freePlanId = (function (param) {
                      return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    })("Expect to find Free plan");
                var subscribeUserToServicePlanPromise = Curry.app(client.rescript_mutate, [
                      {
                        query: query$5,
                        Raw: Raw$5,
                        parse: parse$5,
                        serialize: serialize$5,
                        serializeVariables: serializeVariables$5
                      },
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      {
                        customerId: userId,
                        servicePlanId: freePlanId
                      }
                    ]);
                return PromiseUtils$SmartcutsMacros.map(subscribeUserToServicePlanPromise, (function (createSubscriptionResult) {
                              if (createSubscriptionResult.TAG !== /* Ok */0) {
                                return {
                                        TAG: /* Error */1,
                                        _0: Belt_MapString.fromArray([[
                                                "SubscribeUserToServicePlan",
                                                createSubscriptionResult._0
                                              ]])
                                      };
                              }
                              var subscriptionId = createSubscriptionResult._0.data.createSubscription._id;
                              return {
                                      TAG: /* Ok */0,
                                      _0: [
                                        userId,
                                        subscriptionId
                                      ]
                                    };
                            }));
              }
              var error = userResponse._0;
              if (servicePlansResponse.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: Belt_MapString.fromArray([[
                                    "CreateUser",
                                    error
                                  ]])
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: Belt_MapString.fromArray([
                                  [
                                    "CreateUser",
                                    error
                                  ],
                                  [
                                    "AllServicePlans",
                                    servicePlansResponse._0
                                  ]
                                ])
                          });
              }
            });
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "planName",
                Decco.stringToJson(v.planName)
              ],
              [
                "isPaying",
                Decco.optionToJson(Decco.boolToJson, v.isPaying)
              ],
              [
                "remainingExecutionSteps",
                Decco.intToJson(v.remainingExecutionSteps)
              ],
              [
                "expirationDate",
                Decco.floatToJson(v.expirationDate)
              ],
              [
                "stripeCustomerId",
                Decco.optionToJson(Decco.stringToJson, v.stripeCustomerId)
              ],
              [
                "executionSteps",
                Decco.intToJson(v.executionSteps)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var planName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "planName"), null));
    if (planName.TAG === /* Ok */0) {
      var isPaying = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "isPaying"), null));
      if (isPaying.TAG === /* Ok */0) {
        var remainingExecutionSteps = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "remainingExecutionSteps"), null));
        if (remainingExecutionSteps.TAG === /* Ok */0) {
          var expirationDate = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "expirationDate"), null));
          if (expirationDate.TAG === /* Ok */0) {
            var stripeCustomerId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stripeCustomerId"), null));
            if (stripeCustomerId.TAG === /* Ok */0) {
              var executionSteps = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "executionSteps"), null));
              if (executionSteps.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          id: id._0,
                          planName: planName._0,
                          isPaying: isPaying._0,
                          remainingExecutionSteps: remainingExecutionSteps._0,
                          expirationDate: expirationDate._0,
                          stripeCustomerId: stripeCustomerId._0,
                          executionSteps: executionSteps._0
                        }
                      };
              }
              var e = executionSteps._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".executionSteps" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = stripeCustomerId._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".stripeCustomerId" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = expirationDate._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".expirationDate" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = remainingExecutionSteps._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".remainingExecutionSteps" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = isPaying._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".isPaying" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = planName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".planName" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function fromGraphqlResponse(response) {
  return {
          id: response._id,
          planName: response.servicePlan.name,
          isPaying: Belt_Option.map(response.subtotal, (function (subtotal) {
                  return subtotal > 0;
                })),
          remainingExecutionSteps: response.remainingExecutionSteps,
          expirationDate: Json_decode.date(response.expirationDate).getTime(),
          stripeCustomerId: response.stripeCustomerId,
          executionSteps: response.servicePlan.executionSteps
        };
}

var PlanSubscription = {
  t_encode: t_encode,
  t_decode: t_decode,
  fromGraphqlResponse: fromGraphqlResponse
};

function consoleError(v) {
  switch (v.TAG | 0) {
    case /* GraphqlErrorFetchActiveSubscriptions */0 :
        return DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.consoleError(v._0);
    case /* HttpErrorRequestFreePlanRenewal */1 :
        console.error("HttpErrorRequestFreePlanRenewal", v._0, v._1);
        return ;
    case /* DecodeErrorRequestFreePlanRenewal */2 :
        console.error("DecodeErrorRequestFreePlanRenewal", v._0);
        return ;
    
  }
}

function make(user) {
  var client = Apollo$SmartcutsMacros.makeClient(undefined, user.token, undefined);
  var myActiveSubscriptionsPromise = Curry._6(client.rescript_query, {
        query: query$2,
        Raw: Raw$2,
        parse: parse$2,
        serialize: serialize$2,
        serializeVariables: serializeVariables$2
      }, undefined, undefined, undefined, undefined, undefined);
  return myActiveSubscriptionsPromise.then(function (result) {
              if (result.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* GraphqlErrorFetchActiveSubscriptions */0,
                              _0: DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.fromApolloClientError(result._0)
                            }
                          });
              }
              var activeSubscriptions = ArrayUtils$SmartcutsMacros.sort2(Belt_Array.keepMap(result._0.data.myActiveSubscriptions.data, (function (x) {
                          return x;
                        })), (function (subscription1, subscription2) {
                      var match = subscription1.subtotal;
                      var match$1 = subscription2.subtotal;
                      if (match !== undefined) {
                        if (match$1 !== undefined) {
                          if (match > 0 && subscription1.remainingExecutionSteps > 0 && match$1 <= 0) {
                            return -1;
                          }
                          if (match <= 0 && subscription2.remainingExecutionSteps > 0 && match$1 > 0) {
                            return 1;
                          }
                          
                        } else if (match > 0 && subscription1.remainingExecutionSteps > 0) {
                          return -1;
                        }
                        
                      } else if (match$1 !== undefined && match$1 > 0 && subscription2.remainingExecutionSteps > 0) {
                        return 1;
                      }
                      return subscription2.remainingExecutionSteps - subscription1.remainingExecutionSteps | 0;
                    }));
              var isSubscriptionFree = function (subscription) {
                var subtotal = subscription.subtotal;
                if (subtotal !== undefined) {
                  return subtotal === 0;
                } else {
                  return true;
                }
              };
              var activeSubscription = Belt_Array.get(Belt_Array.keep(activeSubscriptions, (function (subscription) {
                          return subscription.remainingExecutionSteps > 0;
                        })), 0);
              var maybeActiveSubscription;
              if (activeSubscription !== undefined) {
                maybeActiveSubscription = activeSubscription;
              } else {
                var paidSubscription = ArrayUtils$SmartcutsMacros.firstMatch((function (subscription) {
                        return !isSubscriptionFree(subscription);
                      }), activeSubscriptions);
                maybeActiveSubscription = paidSubscription !== undefined ? paidSubscription : ArrayUtils$SmartcutsMacros.firstMatch(isSubscriptionFree, activeSubscriptions);
              }
              if (maybeActiveSubscription !== undefined) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: fromGraphqlResponse(maybeActiveSubscription)
                          });
              } else {
                Segment$SmartcutsMacros.trackUserAttemptToRenewFreePlan(undefined);
                return fetch(Config$SmartcutsMacros.hostnameForUser(user) + "/api/renew_free_subscription", Fetch.RequestInit.make(/* Post */2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function (response) {
                            var statusCode = response.status;
                            if (statusCode !== 200) {
                              return response.text().then(function (errorMessage) {
                                          Segment$SmartcutsMacros.TrackUserFailedToRenewFreePlan.track("Got " + (String(statusCode) + (": " + errorMessage)));
                                          return Promise.resolve({
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        TAG: /* HttpErrorRequestFreePlanRenewal */1,
                                                        _0: statusCode,
                                                        _1: errorMessage
                                                      }
                                                    });
                                        });
                            } else {
                              return PromiseUtils$SmartcutsMacros.resolveWith((function (json) {
                                            var newSubscription = t_decode(json);
                                            if (newSubscription.TAG === /* Ok */0) {
                                              Segment$SmartcutsMacros.trackUserSuccessfullyRenewedFreePlan(undefined);
                                              return {
                                                      TAG: /* Ok */0,
                                                      _0: newSubscription._0
                                                    };
                                            }
                                            Segment$SmartcutsMacros.TrackUserFailedToRenewFreePlan.track("Failed to decode server response");
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      TAG: /* DecodeErrorRequestFreePlanRenewal */2,
                                                      _0: newSubscription._0
                                                    }
                                                  };
                                          }), response.json());
                            }
                          });
              }
            });
}

var RequestActiveSubscription = {
  consoleError: consoleError,
  make: make
};

function consumeSubscriptionBy(subscriptionId, numExecutionSteps, client) {
  return PromiseUtils$SmartcutsMacros.map(Curry.app(client.rescript_mutate, [
                  {
                    query: query$3,
                    Raw: Raw$3,
                    parse: parse$3,
                    serialize: serialize$3,
                    serializeVariables: serializeVariables$3
                  },
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  {
                    subscriptionId: subscriptionId,
                    numExecutionSteps: numExecutionSteps
                  }
                ]), (function (result) {
                if (result.TAG !== /* Ok */0) {
                  return {
                          TAG: /* Error */1,
                          _0: DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.fromApolloClientError(result._0)
                        };
                }
                var response = result._0;
                var data = response.data.consumeSubscription;
                if (data !== undefined) {
                  return {
                          TAG: /* Ok */0,
                          _0: data.remainingExecutionSteps
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: {
                            TAG: /* MissingInExpectedJson */7,
                            _0: [
                              "consumeSubscription",
                              "remainingExecutionSteps"
                            ],
                            _1: response
                          }
                        };
                }
              }));
}

function updateTopSites(client, userId, topSites) {
  return PromiseUtils$SmartcutsMacros.map(Curry.app(client.rescript_mutate, [
                  {
                    query: query$1,
                    Raw: Raw$1,
                    parse: parse$1,
                    serialize: serialize$1,
                    serializeVariables: serializeVariables$1
                  },
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  {
                    id: userId,
                    partialUpdate: {
                      email: undefined,
                      inviteToken: undefined,
                      role: undefined,
                      active: undefined,
                      failures: undefined,
                      authoredSmartcuts: undefined,
                      topSites: Belt_Array.map(topSites, (function (param) {
                              return {
                                      url: param.url,
                                      title: param.title
                                    };
                            })),
                      installedSmartcuts: undefined,
                      scheduledTriggers: undefined,
                      build: undefined,
                      subscriptions: undefined,
                      userFlags: undefined,
                      finishedOnboarding: undefined,
                      completedExtraStepsBonuses: undefined,
                      credentials: undefined
                    }
                  }
                ]), (function (result) {
                return ResultUtils$SmartcutsMacros.mapError2(result, DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.fromApolloClientError);
              }));
}

function finishOnboarding(client, userId) {
  return Curry.app(client.rescript_mutate, [
                  {
                    query: query$1,
                    Raw: Raw$1,
                    parse: parse$1,
                    serialize: serialize$1,
                    serializeVariables: serializeVariables$1
                  },
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  {
                    id: userId,
                    partialUpdate: {
                      email: undefined,
                      inviteToken: undefined,
                      role: undefined,
                      active: undefined,
                      failures: undefined,
                      authoredSmartcuts: undefined,
                      topSites: undefined,
                      installedSmartcuts: undefined,
                      scheduledTriggers: undefined,
                      build: undefined,
                      subscriptions: undefined,
                      userFlags: undefined,
                      finishedOnboarding: true,
                      completedExtraStepsBonuses: undefined,
                      credentials: undefined
                    }
                  }
                ]).then(function (result) {
                return Promise.resolve(ResultUtils$SmartcutsMacros.mapError2(result, DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.fromApolloClientError));
              }).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve(undefined);
              }
              var error = result._0;
              if (error === 3) {
                return Promise.reject({
                            RE_EXN_ID: JsPromiseErrorUtils$SmartcutsMacros.User_logged_out
                          });
              } else {
                DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.consoleError(error);
                return Util$SmartcutsMacros.logAndRaiseJsError("Failed to finishedOnboarding() for user");
              }
            });
}

var Raw$6 = {};

var query$6 = (require("@apollo/client").gql`
  query ($userId: ID!)  {
    findUserByID(id: $userId)  {
      __typename
      _id
      finishedOnboarding
    }
  }
`);

function parse$6(value) {
  var value$1 = value.findUserByID;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.finishedOnboarding;
    tmp = {
      __typename: value$1.__typename,
      _id: value$1._id,
      finishedOnboarding: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          findUserByID: tmp
        };
}

function serialize$6(value) {
  var value$1 = value.findUserByID;
  var findUserByID;
  if (value$1 !== undefined) {
    var value$2 = value$1.finishedOnboarding;
    var finishedOnboarding = value$2 !== undefined ? value$2 : null;
    var value$3 = value$1._id;
    var value$4 = value$1.__typename;
    findUserByID = {
      __typename: value$4,
      _id: value$3,
      finishedOnboarding: finishedOnboarding
    };
  } else {
    findUserByID = null;
  }
  return {
          findUserByID: findUserByID
        };
}

function serializeVariables$6(inp) {
  return {
          userId: inp.userId
        };
}

function makeVariables$6(userId, param) {
  return {
          userId: userId
        };
}

var GetUserById_inner = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$6,
  makeVariables: makeVariables$6
};

var include$6 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$6,
      Raw: Raw$6,
      parse: parse$6,
      serialize: serialize$6,
      serializeVariables: serializeVariables$6
    });

var GetUserById_refetchQueryDescription = include$6.refetchQueryDescription;

var GetUserById_use = include$6.use;

var GetUserById_useLazy = include$6.useLazy;

var GetUserById_useLazyWithVariables = include$6.useLazyWithVariables;

var GetUserById = {
  GetUserById_inner: GetUserById_inner,
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$6,
  makeVariables: makeVariables$6,
  refetchQueryDescription: GetUserById_refetchQueryDescription,
  use: GetUserById_use,
  useLazy: GetUserById_useLazy,
  useLazyWithVariables: GetUserById_useLazyWithVariables
};

function getOnboardingStatus(client, userId) {
  return PromiseUtils$SmartcutsMacros.map(Curry._6(client.rescript_query, {
                    query: query$6,
                    Raw: Raw$6,
                    parse: parse$6,
                    serialize: serialize$6,
                    serializeVariables: serializeVariables$6
                  }, undefined, undefined, undefined, undefined, {
                    userId: userId
                  }).then(function (result) {
                  if (result.TAG !== /* Ok */0) {
                    return Promise.resolve(result);
                  }
                  var match = Belt_Option.flatMap(result._0.data.findUserByID, (function (user) {
                          return user.finishedOnboarding;
                        }));
                  if (match !== undefined && match) {
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: true
                              });
                  } else {
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: false
                              });
                  }
                }), (function (result) {
                return ResultUtils$SmartcutsMacros.mapError2(result, (function (error) {
                              return DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.fromApolloClientError(error);
                            }));
              }));
}

exports.CreateUser = CreateUser;
exports.UpdateUserQuery = UpdateUserQuery;
exports.MyActiveSubscriptions = MyActiveSubscriptions;
exports.ConsumeSubscription = ConsumeSubscription;
exports.AllServicePlans = AllServicePlans;
exports.SubscribeUserToServicePlan = SubscribeUserToServicePlan;
exports.createNewUserWithFreeSubscription = createNewUserWithFreeSubscription;
exports.PlanSubscription = PlanSubscription;
exports.RequestActiveSubscription = RequestActiveSubscription;
exports.consumeSubscriptionBy = consumeSubscriptionBy;
exports.updateTopSites = updateTopSites;
exports.finishOnboarding = finishOnboarding;
exports.GetUserById = GetUserById;
exports.getOnboardingStatus = getOnboardingStatus;
/* query Not a pure module */
